<div class="container-fluid">
	<div class="row">
		<footer>
			<div>
				<p class="copyright">© 2024 Vaillant</p>
				<nav>
					<ul>
						<li *ngFor="let link of getConfig().footerLinks" class="footer-link">
							<a target="_blank" href="{{ link.url }}">{{ getTranslator().tr(link.caption) }}</a>
						</li>
					</ul>
				</nav>
			</div>
		</footer>
	</div>
</div>